import { View } from "./View";

export interface IOnboardingStepDisplayProps {
  step: number;
  stepsPerPage: number;
  totalSteps: number;
}

export const OnboardingStepDisplay = (props: IOnboardingStepDisplayProps) => {
  return <View {...props} />;
};
